var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KeyValue',{staticClass:"mr-6",attrs:{"caption":_vm.caption,"data-qa":_vm.dataQa,"line":_vm.line}},[_c('div',[(_vm.value && _vm.value !== '0001-01-01T00:00:00')?[_c('span',[_vm._v(_vm._s(_vm.$d(new Date(_vm.value), 'shortDate'))+" ")]),_c('span',[_vm._v(_vm._s(_vm.$d(new Date(_vm.value), 'time')))])]:_c('span',[_vm._v("–")])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }